<header class="nav-header bg-white no-print">
    <!-- <div class="page-header small-screen">
        <div class="container-fluid py-2">
            <div class="d-flex align-items-center justify-content-center gap-3 countainer-2logos-header logo_col">
                <a routerLink="/" class="logo-img-container1 text-decoration-none">
                    <div class="logo-container-div dc-logo position-relative" style="max-width: 140px;">
                        <img src="assets/imgs/uslegword.png" class="img-fluid" alt="US Legalization">
                        <div class="usl usl-logotxtin"></div>
                    </div>
                </a>
                <a routerLink="/">
                    <img src="assets/imgs/usleg-logo-animated.gif" alt="US Legalization" class="img-fluid" style="max-height: 50px;">
                </a>
            </div>
        </div>
    </div> -->

    @if (pageTitle()) {
    <div id="header_count">
        <div class="forMapImg" [style.background-image]="'url(assets/imgs/banners/' + countryName() + '-map.jpg)'"
            style="background-color: #d9cfda;">
        </div>

        <div class="navbar-menu menu2">
            <div class="container-fluid h-100 p-0">
                <div class="row mainhead-div m-0 align-items-center h-100">
                    <div class="col-12 col-md-9 customcol-9 d-flex align-items-center gap-2 px-3">
                        <div class="logotxt-div logo-img-container2 flex-shrink-0 d-sm-block">
                            <img src="assets/imgs/uslegword.png" width="130" class="dc-logo img-fluid" alt="US Legalization">
                            <div class="usl usl-logotxt"></div>
                        </div>
                        <div class="maintit-div flex-grow-1 d-sm-block d-none">
                            <h1 class="maintit_h1" [innerHTML]="pageTitle()"></h1>
                        </div>
                    </div>
                    <div class="col-md-3 d-none d-xl-flex align-items-center justify-content-end audflg-div pe-4">
                        <img [src]="'assets/imgs/flags/' + countryName() + '.gif'" id="flg-ban" class="img-fluid"
                            alt="Flag">
                    </div>
                </div>
            </div>
        </div>
    </div>
    } @else {
    <div class="top-banner-strip d-none d-lg-block"></div>
    }

    <div class="row m-0" id="theNav">
        <div class="col-md-12 col-navbar p-0">
            <nav class="navbar navbar-dark navinv-nav navbar-expand-lg w-100" style="background-color: #625983;">
                <div class="container-fluid px-3">
                    <button type="button" class="navbar-toggler border-0 p-1" (click)="toggleMenu()"
                        [attr.aria-expanded]="!isMenuCollapsed()" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <!-- Mobile Cart Icon in Nav Bar for Instant Visibility -->
                    <a routerLink="/cart" class="nav-link text-white d-lg-none d-flex align-items-center gap-1 py-1 px-2 rounded-2" style="background: rgba(255,255,255,0.15);">
                        <i class="fas fa-cart-arrow-down text-warning"></i>
                        <span class="badge bg-white text-dark fw-bold">{{ orderProcessing.cartItemCount() }}</span>
                    </a>
                    <div class="collapse navbar-collapse curve" id="bs-example-navbar-collapse-1" [class.show]="!isMenuCollapsed()">
                        <nav id="nav-main" class="w-100">
                            <ul class="nav navbar-nav d-flex flex-lg-row flex-column w-100 align-items-lg-center position-relative py-2 py-lg-0">
                                @if (!pageTitle()) {
                                <li class="nav-item logo-item d-none d-lg-block me-3">
                                    <a routerLink="/" class="d-block" style="max-width: 150px; max-height: 50px;">
                                        <div class="logo-container-div dc-logo end-0"
                                            style="margin: 0; margin-top: -70px;">
                                            <img src="assets/imgs/uslegword.png" width="100%" alt="Logo">
                                            <div class="usl usl-logotxt" style="left: 1.5%; top: 2%;"></div>
                                        </div>
                                    </a>
                                </li>
                                }
                                <li id="homeLink" class="nav-item ms-lg-2">
                                    <a class="nav-link text-white fw-bold d-flex align-items-center py-2 px-3" routerLink="/" (click)="closeMenu()">
                                        <i class="fas fa-home me-1 text-warning-icon"></i>Home
                                    </a>
                                </li>
                                <li id="aboutLink" class="nav-item ms-lg-3">
                                    <a class="nav-link text-white fw-bold d-flex align-items-center py-2 px-3" routerLink="/pay" (click)="closeMenu()">
                                        <i class="fas fa-dollar-sign me-1 text-warning-icon"></i>Pay Invoice
                                    </a>
                                </li>
                                <li id="historyLink" class="nav-item ms-lg-3">
                                    <a class="nav-link text-white fw-bold d-flex align-items-center py-2 px-3"
                                        href="javascript:void(0)" (click)="authService.openLoginModal(); closeMenu()">
                                        <i class="far fa-clock me-1 text-warning-icon"></i>Account History
                                    </a>
                                </li>
                                <li id="contactLink" class="nav-item ms-lg-3">
                                    <a class="nav-link text-white fw-bold d-flex align-items-center py-2 px-3"
                                        routerLink="/contact" (click)="closeMenu()">
                                        <i class="fas fa-phone-alt me-1 text-warning-icon"></i>Contact Us
                                    </a>
                                </li>

                                <li class="cart-div nav-item ms-lg-auto d-none d-lg-block">
                                    <a class="nav-link text-white d-flex align-items-center" routerLink="/cart"
                                        style="padding:0px">
                                        <i class="fas fa-cart-arrow-down me-1"
                                            style="color: yellow; font-size: 1.25rem;"></i>
                                        <span class="cart-num"
                                            style="background: white; color: #625983; border-radius: 5px; font-weight: bold; margin: 0 5px;">
                                            {{ orderProcessing.cartItemCount() }}
                                        </span>
                                        <span>item(s)</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</header>
<app-login></app-login>